import styled from 'styled-components'

const StyledLinkIcon = styled.a`
  height: 22px;
  display: flex;
  align-items: center;
  text-decoration: none;
`

const StyledIconContainer = styled.div`
  height: 22px;
  display: flex;
  align-items: center;
`

const StyledContent = styled.div`
  /* line-clamp */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
`

export { StyledIconContainer, StyledLinkIcon, StyledContent }
